// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__fdL_L","alignCenter":"style_alignCenter__GbX3t"};